import React from 'react'
import useTemplate from '../../../../hooks/services/useTemplate'
import { isNotSuccessful } from '../../../../hooks/useQuery'
import SelectFieldFilter from '../../../molecules/filters/SelectFieldFilter'

const FormTypeFilter = () => {
  const { getPublishedTemplates } = useTemplate()
  const { data: templates, status } = getPublishedTemplates()

  if (isNotSuccessful(status)) return null

  const templateList = templates.map(t => ({ id: `template_${t.id}`, name: `Plantilla: ${t.name}` }))
  const formTypeList = [{ id: 'simple', name: 'Simple' }, ...templateList]

  return (
    <>
      <SelectFieldFilter
        className="w-full mt-3"
        label="Tipo de formulario"
        name="attended_request_form_type"
        margin="none"
        size="full"
        emptyLabel="Todos"
        options={formTypeList}
      />
    </>
  )
}

export default FormTypeFilter
